var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestricted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32911",
    "data-name": "Group 32911",
    transform: "translate(22922 4463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13035",
    "data-name": "Rectangle 13035",
    width: 32,
    height: 32,
    transform: "translate(-22922 -4463)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "forbidden",
    transform: "translate(-22920 -4461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32910",
    "data-name": "Group 32910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33214",
    "data-name": "Path 33214",
    d: "M14,0A14,14,0,1,0,28,14,14,14,0,0,0,14,0ZM6.224,4.848a12,12,0,0,1,15.517,0l-16.9,16.9A11.988,11.988,0,0,1,6.224,4.848Zm15.552,18.3a12,12,0,0,1-15.517,0l16.9-16.9A11.988,11.988,0,0,1,21.776,23.152Z",
    fill: "#ff2d54"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricted);
export default __webpack_public_path__ + "static/media/restricted.1d797decd70b5e35da13355c482e5b79.svg";
export { ForwardRef as ReactComponent };